import { EMPTY_OBJECT } from '../../../constants/common'

// The newsband detail endpoint omits the analytics permissions the feed list
// provides, so staff (admin/manager) get the viewers/reports actions by default.
export function getNewsboardPostProfileFooterData({ isStaff, postData }) {
  const post = postData || EMPTY_OBJECT
  const permissions = post.permissions || EMPTY_OBJECT

  return {
    ...post,
    isProfile: true,
    permissions: {
      ...permissions,
      can_view_post_report: permissions.can_view_post_report ?? isStaff,
      can_view_viewers: permissions.can_view_viewers ?? isStaff,
    },
  }
}
